import * as z from 'zod';
import type { ComputedFieldSummaryPayload } from '@rossum/api-client/internal';
import type { SchemaSection } from '@rossum/api-client/schemas';
import type { Dataset, DatasetColumn } from '../../../../../datasets/types';

export type VariablesMap = Record<string, { __formula: string }>;

export const queryObjectSchema = z.object({
  '//': z.string().optional(),
  aggregate: z.unknown(),
});

export type QueryObject = z.infer<typeof queryObjectSchema>;

export type ComplexDataLookupPayload = {
  dataset: string;
  queries: QueryObject[];
  variables: VariablesMap;
};

export type Placeholder = {
  id: string;
  originalValue: string;
  displayLabel: string;
};

export type Variable = {
  id: number;
  name: string;
  value: string;
};

/** Everything an editor variant needs from the shell, which derives all of it once. */
export type LookupEditorProps = {
  value: ComplexDataLookupPayload;
  onChange: (value: ComplexDataLookupPayload) => void;
  schemaContent: SchemaSection[];
  lookupSchemaId: string;
  lookupLabel: string;
  // A field with no label or no ID cannot be suggested for or summarised.
  isRequiredInfoMissing: boolean;
  table: Dataset | null;
  tables: Dataset[];
  columnOptions: (DatasetColumn & { samples: string[] })[];
  // Debounced, so the summary endpoint always gets a field id and a schema that agree.
  summaryPayload: ComputedFieldSummaryPayload;
  // Frozen while the JSON editor has focus, so summaries do not recompute on every keystroke.
  summaryValue: { queries: QueryObject[]; variables: VariablesMap };
  isSourceEditorOpen: boolean;
  onToggleSourceEditor: () => void;
};
